<template>
    <section id="strojni-park">
        <div class="inner">
            <div id="strojni-park-anchor" class="scroll-to-anchor"></div>

            <div class="pattern pattern-3"></div>
            <div class="pattern pattern-4"></div>
            <div class="darkBg"></div>
            <div class="container">
                <h1>Strojni</h1><br>
                <h1>park</h1>
                
                <div class="vehicles">
                    <div class="row">
                        <div class="col-md-4 col-sm-6 col-lg-3" v-for="v in data" :key="v.id">
                            <figure>
                                <a :href="'/static/vozila/'+v.image+'.jpg'" :data-title="v.name"  data-mediabox="strojni-park">
                                    <div class="image" :style="{backgroundImage:'url(static/vozila/thumbs/'+v.image+'.jpg)'}"></div>
                                </a>
                                
                            </figure>
                            <figcaption>
                                <div class="flex">
                                    <div class="name">
                                        <span v-html="v.name"></span>
                                        <small v-html="v.extra"></small>
                                    </div>
                                    
                                </div>
                            </figcaption>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </section>
</template>

<script>
require("../scripts/Lightbox.js");
import Vehicles from "./Vehicles/vehicles.json";

export default {
  components: {},
  data() {
    return {
      inRow: 4,
      data: {},
      images: []
    };
  },
  methods: {
    generateModalImages(data) {
      var imageRoot = "/static/vozila/thumbs/";

      for (const v of data) {
        var image = imageRoot + v.image + ".jpg";
        this.images.push({
          src: image,
          title: v.name
        });
      }
    }
  },
  mounted() {
    this.data = Vehicles;
    this.generateModalImages(Vehicles);
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Vehicles.vue